import { Grid, GridItem, Tab, TabContent, Tabs, TabTitleText } from "@patternfly/react-core";
import React, { type FC } from "react";
import SoftwareCodeIcon from "../../../../assets/software-code-red.svg";
import type { DragHandleProps } from "../../../../constants/CardsStructure";
import Env from "../../../../utils/env";
import { NestedDashBoardCard } from "../../shared/NestedDashBoardCard";
import PublishedProductCard from "./PublishedProductCard";
import UnfinishedProductCard from "./UnfinishedProductCard";

interface IActiveProductsCardProps {
	activeKey: number;
	dragHandleProps?: DragHandleProps | undefined;
}

const ActiveProductsCard: FC<IActiveProductsCardProps> = ({ activeKey, dragHandleProps }) => {
	const [activeTabKey, setActiveTabKey] = React.useState<string | number>(activeKey | 0);
	const unfinishedProductsRef = React.createRef<HTMLElement>();
	const publishedProductsRef = React.createRef<HTMLElement>();

	const handleTabClick = (
		_event: React.MouseEvent<any> | React.KeyboardEvent | MouseEvent,
		tabIndex: string | number,
	) => {
		setActiveTabKey(tabIndex);
	};

	return (
		<NestedDashBoardCard
			title="Software products"
			logo={SoftwareCodeIcon}
			logoPosition="left"
			dragHandleProps={dragHandleProps}
			bodyNode={
				<Grid hasGutter style={{ minHeight: "21em" }}>
					<GridItem span={3}>
						<Tabs
							activeKey={activeTabKey}
							isVertical={true}
							onSelect={handleTabClick}
							aria-label="Tab showing unfinished and published products"
							role="region"
						>
							<Tab
								eventKey={0}
								title={<TabTitleText>Unfinished product listings</TabTitleText>}
								tabContentId="unfinishedProducts"
								tabContentRef={unfinishedProductsRef}
							/>
							<Tab
								eventKey={1}
								title={<TabTitleText>Published products</TabTitleText>}
								tabContentId="publishedProducts"
								tabContentRef={publishedProductsRef}
							/>
						</Tabs>
					</GridItem>
					<GridItem span={9} style={{ display: "grid" }}>
						<div style={{ gridArea: "1/1", visibility: activeTabKey === 0 ? "visible" : "hidden" }}>
							<TabContent
								eventKey={0}
								id="unfinishedProducts"
								aria-label="This is content for unfinished products tab"
								ref={unfinishedProductsRef}
							>
								<UnfinishedProductCard />
							</TabContent>
						</div>
						<div style={{ gridArea: "1/1", visibility: activeTabKey === 1 ? "visible" : "hidden" }}>
							<TabContent
								eventKey={1}
								id="publishedProducts"
								aria-label="This is content for published products tab"
								ref={publishedProductsRef}
							>
								<PublishedProductCard />
							</TabContent>
						</div>
					</GridItem>
				</Grid>
			}
			footerItems={[
				{ link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products`, label: "View all products" },
				{ link: `${Env.ConnectPortalUrls[Env.getEnvName()]}manage/products?create=true`, label: "Add a new product" },
			]}
		/>
	);
};

export default ActiveProductsCard;
